<template>
    <div class="flex items-center gap-2">
        <Button type="button" @click="decrement" :disabled="value <= min" severity="default" size="sm" rounded :aria-label="$t('Decrease quantity')">
            <i class="icon-minus" aria-hidden="true"></i>
        </Button>

        <label :for="inputId" class="sr-only">{{ $t('Quantity') }}</label>
        <Input :id="inputId" type="number" v-model="value" :min="min" :max="max" size="sm" class="w-10 border-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" />

        <Button type="button" @click="increment" :disabled="value >= max" severity="default" size="sm" rounded :aria-label="$t('Increase quantity')">
            <i class="icon-plus" aria-hidden="true"></i>
        </Button>
    </div>
</template>

<script setup>
const inputId = `qty-${useId()}`

const modelValue = defineModel({
    type: Number,
})

const props = defineProps({
    min: {
        type: Number,
        default: 0,
    },
    max: {
        type: Number,
        default: 9999,
    },
})

const value = computed(() => (typeof modelValue.value === 'number' ? modelValue.value : props.min))

function clamp(val) {
    return Math.min(props.max, Math.max(props.min, val))
}

function increment() {
    modelValue.value = clamp(value.value + 1)
}

function decrement() {
    modelValue.value = clamp(value.value - 1)
}
</script>
